<page-content [fullPageWidth]="true" scrollTracker (scrolled)="updateScrollPos($event)" class="page-content">
  <header-elitment header></header-elitment>
  <error-401 *ngIf="is401"></error-401>
  <error-404 *ngIf="is404"></error-404>
  <div left-menu class="left-menu-width-hack"></div>
  <div class="editor" *ngIf="!is401 && !is404">
    <div [ngClass]="isLeftPanelOpen ? 'leftPanel open' : 'leftPanel'">
      <div class="content">
        <div class="generalItem">
          <div id="main-drop-items"
               class="cdk-drop-list generic-item-container"
               cdkDropList
               cdkDropListData="generalItem"
               [cdkDropListEnterPredicate]="noReturnPredicate"
               [cdkDropListConnectedTo]="exerciceDropList.concat('root-drop-list')"
          >
            <div cdkDrag class="generic-item-container" [cdkDragData]="getNewBloc()">
              <div class="generic-item bloc" [matTooltip]="'New_bloc' | translate">
                <mat-icon>add_box</mat-icon>
              </div>
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
            </div>
            <div cdkDrag class="generic-item-container" [cdkDragData]="getNewRest()">
              <div class="generic-item rest" [matTooltip]="'New_rest' | translate">
                <mat-icon>pause_circle_outline</mat-icon>
              </div>
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
            </div>
            <div cdkDrag class="generic-item-container" [cdkDragData]="getNewComment()">
              <div class="generic-item comment" [matTooltip]="'New_comment' | translate">
                <mat-icon>comment</mat-icon>
              </div>
              <div class="drag-handle" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="exercicePanel" #exercicePanel>
          <div class="search">
            <mat-form-field color="primary">
              <input #searchExercise matInput type="text" maxlength="255" placeholder="{{ 'Filter' | translate }}">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
          <exercice-category-filters class="search"
                                     [selectedCategoryIds]="selectedCategoryIds"
                                     (onCategoryClicked)="onCategoryClicked($event)"
                                     [displayStyle]="'dropdown'"/>

          <exercice-category-sorting class="search" [fullWidth]="true" [selectedSort]="selectedSort" (onSortSelection)="onSortSelection($event)"></exercice-category-sorting>

          <div class="exercice-list-wrapper">
            <div id="exercice-drop-items"
                 class="cdk-drop-list exerciceList"
                 *ngIf="!sideLoading"
                 cdkDropList
                 [cdkDropListEnterPredicate]="noReturnPredicate"
                 [cdkDropListConnectedTo]="exerciceDropList">
              <div *ngIf="!(exerciseRows$ | async)" class="exerciceList">
                {{ 'No_exercice_found' | translate }}
              </div>
              <ng-container *ngFor="let exerciseRow of exerciseRows$ | async; let i = index">
                <div cdkDrag
                     [cdkDragData]="getNewExercice(exerciseRow)"
                     class="exerciceItem">
                  <div class="drag-handle"
                       cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                  </div>
                  <exercice-preview [exerciceRow]="exerciseRow"
                                    [className]="isLeftPanelOpen ? 'expanded' : ''">
                  </exercice-preview>
                </div>
              </ng-container>
            </div>
            <center-loader class="paginator-data-placeholder min-h-side-loader" *ngIf="sideLoading"></center-loader>
          </div>
          <mat-paginator #paginator
                         [class.hidden]="exerciseDatasource?.totalItems == 0"
                         hidePageSize
                         [pageSize]="exercicesPerPage"
                         [length]="exerciseDatasource.totalItems"
                         showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>

      <div class="toggle-button" (click)="toggleLeftPanel()">
        <mat-icon matSuffix *ngIf="!isLeftPanelOpen">arrow_right</mat-icon>
        <mat-icon matSuffix *ngIf="isLeftPanelOpen">arrow_left</mat-icon>
      </div>
    </div>

    <div class="sessionEditor">
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" *ngIf="sessionRow !== null">
        <div fxFlex="100">
          <div class="session-aside-panel">
            <div class="line flex flex-col" *ngIf="isLangSelectable">
              <label class="language-label">{{ 'Available_languages' | translate }}:</label>
              <div class="language-checkbox-group">
              <mat-checkbox
                *ngFor="let lang of availableLangs"
                [ngModel]="isLangSelected(lang.id) || false"
                (ngModelChange)="toggleLanguage(lang.id, $event)">
                {{ lang.shortName }}
              </mat-checkbox>
              </div>
              <mat-error *ngIf="languagesFormControl.invalid">
                {{ 'select_at_least_one_language' | translate }}
              </mat-error>
            </div>

            <div class="session-general">
              <div fxLayout="row" fxLayoutGap="20px">
                <div fxFlex="50">
                  <mat-form-field color="primary">
                    <input
                      matInput
                      type="text"
                      [required]="true"
                      [maxlength]="TITLE_MAX_LENGTH"
                      [placeholder]="'sessionTitle' | translate"
                      [formControl]="sessionTitleFormControl">
                    <mat-error *ngIf="sessionTitleFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field color="primary">
                    <textarea
                      *ngIf="sessionRow !== null"
                      matInput
                      cdkTextareaAutosize
                      [maxlength]="COMMENTS_MAX_LENGTH"
                      [(ngModel)]="sessionRow.comment"
                      [placeholder]="'generalComment' | translate"
                      (ngModelChange)="onGlobalCommentChange($event)">
                    </textarea>
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="20px">
                <div fxFlex="50" class="line-large-margin">
                  <mat-form-field color="primary">
                    <input matInput
                           #tagsInput
                           [formControl]="tagsFormControl"
                           type="text"
                           [maxlength]="TAGS_MAX_LENGTH"
                           [placeholder]="'Tags' | translate">
                    <mat-error *ngIf="tagsFormControl.invalid">{{ 'insert_at_least_one_tag' | translate }}</mat-error>
                    <mat-hint align="end">{{ 'Tags_hint' | translate }}</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <sessions-session-general-panel class="component-details"
                                            *ngIf="sessionRow !== null"
                                            [organization]="organization"
                                            [(session)]="sessionRow"
                                            [(sessionItems)]="sessionItems"
                                            (onIntensitySliderChange)="onIntensitySliderChange($event)"
                                            (onTotalTimeChange)="onTotalTimeChange($event)"
                                            (onValuesAreGood)="changeAllValuesAreGood(true)"
                                            (onValuesAreNotGood)="changeAllValuesAreGood(false)">
              <div mainAction>
                <main-action [title]="'Save'"
                             [icon]="'check'"
                             [isLoading]="isLoading"
                             [disabled]="isLoading || !allValuesAreGood || isRefreshLoading"
                             (onAction)="onSaveClicked($event)">
                </main-action>
                <main-action [title]="'Close_edit_mode'"
                             [icon]="'close'"
                             [color]="'none'"
                             [disabled]="isLoading || isRefreshLoading"
                             [right]="104"
                             (onAction)="onCancelClicked()">
                </main-action>
                <main-action [disabled]="isLoading || hasPendingChanges"
                             [title]="'Refresh' | translate"
                             [icon]="'refresh'"
                             [isLoading]="isRefreshLoading"
                             [color]="'none'"
                             [bottom]="88"
                             (onAction)="onRefreshClicked()">
                </main-action>
              </div>
            </sessions-session-general-panel>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
        <div fxFlex="100" *ngIf="sessionRow !== null">
          <div id="root-drop-list"
               class="cdk-drop-list root-drop-list"
               cdkDropList
               [cdkDropListData]="sessionItems"
               (cdkDropListDropped)="onDropRoot($event)"
               [cdkDropListEnterPredicate]="rootPredicate"
               [cdkDropListConnectedTo]="exerciceDropList.concat(['main-drop-items'])"
          >
            <div class="no-item-drop-list" *ngIf="sessionItems.length === 0"></div>
            <div class="cdk-drag" cdkDrag *ngFor="let item of sessionItems; let itemIndex = index" [cdkDragData]="item">
              <session-bloc #sessionBlock *ngIf="item.type === 'BLOC'"
                            [blocNumber]="getBlocNumber(item)"
                            [parentIndex]="itemIndex"
                            [itsTheFirst]="itemIndex === 0"
                            [itsTheLast]="itemIndex === sessionItems.length - 1"
                            [data]="item"
                            (click)="editorService.blockClickedEvent(item, sessionBlock, $event)"
                            (onDelete)="onDeleteSessionItem($event)"
                            (onPersonalizedExerciceClicked)="onPersonalizedExerciceClicked($event)"
                            (onDuplicate)="onDuplicateSessionItem($event)"
                            (onMoveUp)="onMoveUpSessionItem($event)"
                            (onMoveDown)="onMoveDownSessionItem($event)"
                            (onDuplicateExerciceAsModel)="onDuplicateExerciceAsModel($event)"
                            (onChanged)="onFormChanged()"
                            (onValuesAreGood)="changeAllValuesAreGood(true)"
                            (onValuesAreNotGood)="changeAllValuesAreGood(false)"
                            (onTimeBasedInfoUpdated)="updateResumedInfo()"
                            (onDrop)="onDropChild($event, item)"
                            [exerciceDropList]="exerciceDropList"
                            [dropPredicate]="blocPredicate"
              >
              </session-bloc>
              <session-comment #sessionComment *ngIf="item.type === 'COMMENT'"
                               [data]="item"
                               [parentIndex]="undefined"
                               [itsTheFirst]="itemIndex === 0"
                               [itsTheLast]="itemIndex === sessionItems.length - 1"
                               (click)="editorService.blockClickedEvent(item, sessionComment, $event)"
                               (onDelete)="onDeleteSessionItem($event)"
                               (onDuplicate)="onDuplicateSessionItem($event)"
                               (onMoveUp)="onMoveUpSessionItem($event)"
                               (onMoveDown)="onMoveDownSessionItem($event)"
                               (onChanged)="onFormChanged()">
              </session-comment>
              <session-rest #sessionRest *ngIf="item.type === 'REST'"
                            [data]="item"
                            [parentIndex]="undefined"
                            [itsTheFirst]="itemIndex === 0"
                            [itsTheLast]="itemIndex === sessionItems.length - 1"
                            (click)="editorService.blockClickedEvent(item, sessionRest, $event)"
                            (onTimeBasedInfoUpdated)="updateResumedInfo()"
                            (onDelete)="onDeleteSessionItem($event)"
                            (onDuplicate)="onDuplicateSessionItem($event)"
                            (onMoveUp)="onMoveUpSessionItem($event)"
                            (onMoveDown)="onMoveDownSessionItem($event)"
                            (onChanged)="onFormChanged()">
              </session-rest>
            </div>
          </div>
          <div class="add-bloc-end" (click)="addNewBlocAtTheEnd()">
            {{ 'addNewBloc' | translate }} <mat-icon>add_circle_outlined</mat-icon>
          </div>
        </div>
        <div fxFlex="300px" fxFlex.lt-sm="100" fxShrink="0" fxGrow="0">
          <div class="component-details-wrapper">
            <div #stickyBoxRef [class.sticky]="sticky">
              <ng-template class="component-details mat-elevation-z1" #editorComponentRef></ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</page-content>
